import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BathroomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bathroom"}/>
}
